// extracted by mini-css-extract-plugin
export default {"archiveButton":"workflows-table-cell__archive-button__RRVyS"};